import React from "react";

interface MembersIconsProps {
  size?: string;
  color?: string;
}

export default function MembersIcons({
  size = "20",
  color = "#79808A",
}: MembersIconsProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 17C18 15.4903 16.6083 14.2067 14.6667 13.7301M13 17C13 15.0847 10.7617 13.5333 8 13.5333C5.23833 13.5333 3 15.0847 3 17M13 10.9333C13.8841 10.9333 14.7319 10.5681 15.357 9.91797C15.9821 9.26784 16.3333 8.38608 16.3333 7.46667C16.3333 6.54725 15.9821 5.66549 15.357 5.01536C14.7319 4.36524 13.8841 4 13 4M8 10.9333C7.11594 10.9333 6.2681 10.5681 5.64298 9.91797C5.01786 9.26784 4.66667 8.38608 4.66667 7.46667C4.66667 6.54725 5.01786 5.66549 5.64298 5.01536C6.2681 4.36524 7.11594 4 8 4C8.88405 4 9.7319 4.36524 10.357 5.01536C10.9821 5.66549 11.3333 6.54725 11.3333 7.46667C11.3333 8.38608 10.9821 9.26784 10.357 9.91797C9.7319 10.5681 8.88405 10.9333 8 10.9333Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
